var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 19C18.5 19.551 18.052 20 17.5 20H7.5C6.948 20 6.5 19.551 6.5 19V8H18.5V19ZM10.5 4.328C10.5 4.173 10.714 4 11 4H14C14.286 4 14.5 4.173 14.5 4.328V6H10.5V4.328ZM21.5 6H20.5H16.5V4.328C16.5 3.044 15.379 2 14 2H11C9.621 2 8.5 3.044 8.5 4.328V6H4.5H3.5C2.95 6 2.5 6.45 2.5 7C2.5 7.55 2.95 8 3.5 8H4.5V19C4.5 20.654 5.846 22 7.5 22H17.5C19.154 22 20.5 20.654 20.5 19V8H21.5C22.05 8 22.5 7.55 22.5 7C22.5 6.45 22.05 6 21.5 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.b784d98c774fc277a8b45bb5047c97b6.svg";
export { ForwardRef as ReactComponent };